import { useQuery } from "@tanstack/react-query";
import { WorkOrdersWorkspace } from "@/components/search-work-orders/WorkOrdersWorkspace";
import { DraftBanner } from "@/components/shared/draft-banner";
import { ErrorState } from "@/components/shared/error-state";
import { PageHeader } from "@/components/shared/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import { fetchWorkOrders, searchWorkOrdersKeys } from "@/mocks/search-work-orders";

export function SearchWorkOrdersPage() {
  const {
    data: workOrders,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: searchWorkOrdersKeys.all,
    queryFn: fetchWorkOrders,
  });

  return (
    <div className="space-y-6">
      <DraftBanner
        epic="EPIC-005"
        run="HR-001"
        subtitle="Work Orders — mock order data, nothing here posts to NetSuite."
      />
      <PageHeader
        title="Work Orders"
        description="Search for work orders, move the ones you want into Selected for update, describe the change, then apply."
      />
      {isError ? (
        <ErrorState message="Couldn't load work orders." onRetry={() => refetch()} />
      ) : isLoading || !workOrders ? (
        <div className="space-y-4">
          <Skeleton className="h-48 w-full rounded-xl" />
          <Skeleton className="h-64 w-full rounded-xl" />
        </div>
      ) : (
        <WorkOrdersWorkspace workOrders={workOrders} />
      )}
    </div>
  );
}
